import React, { useCallback, useRef, useState } from 'react';

import { ImageGalleryBlockData } from 'api/cms';
import { Slideshow } from 'components/Slideshow';
import { useModalContainerFunctions } from 'containers/ShowModalContainer';
import { useElementReachedEffect } from 'utils/screen';

type Props = {
  data: ImageGalleryBlockData;
  blockIndex: number;
};

export function ImageGalleryBlock({ data: { images }, blockIndex }: Props) {
  const [show, setShow] = useState(blockIndex > 2);
  const lazyRef = useRef<HTMLDivElement>(null);

  useElementReachedEffect({
    ref: lazyRef,
    offset: { top: 200 },
    onReach: useCallback(() => setShow(true), []),
  });

  const { showModal } = useModalContainerFunctions();
  const openMediaGallery = useCallback(
    ({ itemIndex }: { itemIndex: number }) => {
      showModal('MEDIA_GALLERY', { items: images, itemIndex });
    },
    [images, showModal]
  );

  if (!show) return <div ref={lazyRef} />;

  return (
    <Slideshow
      items={images}
      data-qa-id="cms-image-gallery"
      round
      onClickIndex={openMediaGallery}
    />
  );
}
